import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './Form.css';
import { FaTimes } from 'react-icons/fa';
import { getDatabase, ref, onValue, update } from 'firebase/database';
import { app } from '../firebase';

const DoorConfig = () => {
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  // const [userDetails, setUserDetails] = useState();
  const [userDetails,setUserDetails]=useState()

  const formData = location.state?.formData || userDetails;

  const initialDropdowns = Array.from({ length: 25 }, (_, index) => ({
    selectedOption: '',
    isDropdown: true,
    isHidden: false,
    additionalFields: {
      field1: '',
      field2: '',
      field3: '',
      field4: '',
    },
  }));

  const [valePersent, setValePersent] = useState('');
console.log('----------------------------->>>>>>>>>>>>>>>>>>>>>>88',location.state?.formData );

  const [dropdowns, setDropdowns] = useState(() => {
    const savedData = JSON.parse(sessionStorage.getItem('doorConfigData'));
    return savedData || (Array.isArray(formData) && formData.length > 0 ? formData : initialDropdowns);
  });

  const saveToSessionStorage = (data) => {
    sessionStorage.setItem('doorConfigData', JSON.stringify(data));
  };

  useEffect(() => {

    const handleBeforeUnload = () => {
      sessionStorage.setItem('isReloading', 'true');
    };

    const handleUnload = () => {
      sessionStorage.removeItem('doorConfigData');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    if (sessionStorage.getItem('isReloading')) {
      sessionStorage.removeItem('isReloading');
      navigate('/');
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, [navigate]);

  const dropdownOptions = [
    ['HAND FORGED', 'LOW PROFILE', 'SLIDING', 'FOLDING'],
    ['SINGLE DOOR', 'DOUBLE DOOR', 'FOLDING DOOR', 'SLIDING DOOR'],
    ["W/SIDELIGHTS", "W/TRANSOM", "W/SIDELIGHT & TRANSOM", "W/OPERABLE GLASS", "W/SIMULATED DIVIDED LIGHTS", "W/TRUE DIVIDED LIGHTS"],
    ['Yes', 'No'],
    ['Yes', 'No'],
    ['1', '1 1/2', '2'],
    ['4', '4 1/2', '5', '5 1/2', '6', '6 1/2', 'TBD', 'CUSTOM'],
    ['1x2', '1 1/2x2', '2x2', '3x2', '4x2', "TBD", "CUSTOM"],
    ['Yes', 'No'],
    ['Yes', 'No'],
    ['Yes', 'No'],
    ['Yes', 'No'],
    ['0'],
    ['N/A', 'PULL HANDLES W/ROLLER LATCHES', 'STANDARD HARDWARE', 'TBD', 'CUSTOM'],
    ['0'],
    ['STEP', 'EXTENDED STEP', 'OUT SWING', 'ADA TOP OF FLOOR', 'ADA-BUTT FLOOR'],
    ['3/4', '1 1/2', '2', '2 1/2'],
    ['Yes', 'No'],
    ['Yes', 'No'],
    ['Yes', 'No'],
    ['LOWE 1', 'LOWE 2', 'LOWE 3', 'FLEMISH', 'OPERABLE', 'FIXED'],
    ['TBD', 'CO1', 'CO2', 'CO3', 'CO4', 'CO5', 'CO6', 'CO7', 'CO8', 'CO9'],
    ['Yes', 'No'],
    ['Yes', 'No'],
    ['Yes', 'No'],
  ];

  const dropdownLabels = [

    'Door Type & Size',
    'Door configuration',
    'Door Transom & Side Lights',
    'Arch Unit',
    'Arch Door',
    'Jamb Width',
    'Jamb Depth',
    'Stile Width Thickness of door',
    'Over 10 Door',
    'Over 14 Unit',
    'Roller Latches Prep',
    'Flush Bolt',
    'Pull Handle',
    'Hardware Prep Type',
    'Deadbolt Installation',
    'Threshold Type',
    'Threshold HT',
    'Trim Exterior',
    'Trim Interior',
    'Bug Screens',
    'Glass Temp IG',
    'Paint Color',
    'Remodel',
    'Installation Out of Town',
    'Freight IN',
  ];

  const fieldLabels = [
    ['Width', 'Height', 'Sqr/ft', 'Unit Cost'], ['Door Swing', 'Hinge', '', 'Unit Cost'],
    [' ', ' ', ' ', ' '], ['Type of Arch', 'Rise of Arch', ' ', 'Unit Cost'],['Type of Arch', 'Rise of Arch', ' ', 'Unit Cost'],
    [' ', ' ', ' ', 'Unit Cost'], [' ', ' ', ' ', 'Unit Cost'],
    [' ', ' ', ' ', 'Unit Cost'],  [' ', ' ', ' ', 'Unit Cost'],
    [' ', ' ', ' ', 'Unit Cost'], ['Item', 'Quantity', ' ', 'Unit Cost'],
    ['Item', 'Quantity', ' ', 'Unit Cost'],  ['Type of Handles Item', ' ', '  ', 'Unit Cost'],
    [' ', ' ', ' ', 'Unit Cost'], ['Type of Lock', ' ', ' ', 'Unit Cost'],
    [' ', ' ', ' ', 'Unit Cost'],   ['Width', ' ', ' ', 'Unit Cost'],
    ['Width', 'Height', 'Sqr/ft', 'Unit Cost'], ['Width', 'Height', 'Sqr/ft', 'Unit Cost'],
    [' ', ' ', ' ', 'Unit Cost'],  ['Width', 'Height', 'Sqr/ft', 'Unit Cost'],
    [' ', ' ', '  ', '   '],   [' ', ' ', ' ', 'Unit Cost'],
    [' ', ' ', ' ', 'Unit Cost'],   [' ', ' ', ' ', 'Unit Cost'],
  ];

  const [staticUnitCosts, setStaticUnitCosts] = useState(() => [
    [60.00], [0.00],  [0.00], [0.00], [0.00],  [0.00],
    [0.00], [8.00],  [0.00],  [0.00], [43.00],   [43.00], [155.00],  [176.00], [75.00],   [170.00],
    [100.00], [8.00],   [8.00],  [140.00],   [22.00],  [0.00],[550.00],[550.00], [300.00], [0.00],
  ]);
  const [doorOption, setDoorOPtion] = useState('')

  useEffect(() => {
  //  if(!id=='undefined'){
    const db = getDatabase(app);
    const userRef = ref(db, `users/${id}`);
    console.log("userRef", userRef);
   

    const unsubscribe = onValue(userRef, (snapshot) => {
      const data = snapshot.val();

// if (location.state?.formData === undefined){
// }

if(id=='undefined'){
  console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~if',id);
  

}else{
  console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-else',id);
  setUserDetails(data.formData)
}

    
      if (Array.isArray(data?.doorData)) {
        data.doorData.forEach((door, index) => {
          const value = door?.selectedOption;
          const newDropdowns = [...dropdowns];
          newDropdowns[index].selectedOption = value;
          // newDropdowns[index].selectedOption = value;

          const usersList = data ? Object.entries(data).map(([id, user]) => ({ id, ...user })) : [];
          console.log("newDropdowns", usersList[0])
          const newData = usersList[0];
      
          setDoorOPtion(value);
          setDropdowns(newData);
          saveToSessionStorage(newDropdowns);

          if (value) {

            const unitCost = staticUnitCosts[index]; // Set unit cost based on selected option
            newDropdowns[index].additionalFields = {
              field1: '',
              field2: '',
              field3: '',
              field4: unitCost,
            };
          } else { 
            newDropdowns[index].additionalFields = {};
          }

          if (value === 'SOME_OPTION') { // Replace with your condition
            newDropdowns[index].isDropdown = false; // Hide dropdown
            newDropdowns[index].isHidden = true; // Additional condition if needed
          } else {
            newDropdowns[index].isDropdown = true;
            newDropdowns[index].isHidden = false;
          }


        });
      } else {
        console.error("doorData is not an array or undefined");
      }

      if (Array.isArray(data?.doorData)) {
        data.doorData.forEach((door, index) => {
          console.log(door);

          const { additionalFields, selectedOption } = door;

          const newDropdowns = [...dropdowns];

          if (additionalFields) {
            Object.keys(additionalFields).forEach(fieldName => {
              newDropdowns[index].additionalFields[fieldName] = additionalFields[fieldName];
            });
          }

          if (index === 0) {
            const width = parseFloat(newDropdowns[index].additionalFields.field1) || 0;
            const height = parseFloat(newDropdowns[index].additionalFields.field2) || 0;
            console.log("width-----------------", width, height)
            const sqrFt = (width * height) / 144;
            newDropdowns[index].additionalFields.field3 = sqrFt.toFixed(2);
            const unitCost = parseFloat(newDropdowns[index].additionalFields.field4) || 0;
            const totalCost = (sqrFt * unitCost * 0.2).toFixed(2);
            setValePersent(totalCost);
            console.log(totalCost);

          } else if (index === 18 || index === 19) {
            const width = parseFloat(newDropdowns[index].additionalFields.field1) || 0;
            const height = parseFloat(newDropdowns[index].additionalFields.field2) || 0;
            const sqrFt = (width + height + height) / 12; // Convert to square feet
            newDropdowns[index].additionalFields.field3 = sqrFt.toFixed(2); // Update the Sqr/ft field
          } else if (index === 21) {
            const width = parseFloat(newDropdowns[index].additionalFields.field1) || 0;
            const height = parseFloat(newDropdowns[index].additionalFields.field2) || 0;
            const sqrFt = (width * height) / 144; // Convert to square feet
            newDropdowns[index].additionalFields.field3 = sqrFt.toFixed(2); // Update the Sqr/ft field
          }

          setDropdowns(newDropdowns);
          saveToSessionStorage(newDropdowns);
        });
      } else {
        console.error("doorData is not an array or undefined");
      }

    });

    return () => unsubscribe();
  //  }
  }, [id]);


  useEffect(() => {
    if (valePersent) {
      setStaticUnitCosts((prevCosts) => {
        const updatedCosts = [...prevCosts];
        updatedCosts[1][0] = parseFloat(valePersent) || 0; // Update index 2
        updatedCosts[3][0] = parseFloat(valePersent) || 0; // Update index 4
        updatedCosts[4][0] = parseFloat(valePersent) || 0; // Update index 5
        updatedCosts[8][0] = parseFloat(valePersent) || 0; // Update index 9
        updatedCosts[9][0] = parseFloat(valePersent) || 0; // Update index 10

        return updatedCosts;
      });
    }

  }, [valePersent]);

  const handleOptionChange = (index, e) => {
    const value = e.target.value;
    const newDropdowns = [...dropdowns];
    newDropdowns[index].selectedOption = value;
    setDoorOPtion(value);
    setDropdowns(newDropdowns);
    saveToSessionStorage(newDropdowns);

    if (value) {

      const unitCost = staticUnitCosts[index]; // Set unit cost based on selected option
      newDropdowns[index].additionalFields = {
        field1: '',
        field2: '',
        field3: '',
        field4: unitCost,
      };
    } else {
      newDropdowns[index].additionalFields = {};
    }

    if (value === 'SOME_OPTION') { // Replace with your condition
      newDropdowns[index].isDropdown = false; // Hide dropdown
      newDropdowns[index].isHidden = true; // Additional condition if needed
    } else {
      newDropdowns[index].isDropdown = true;
      newDropdowns[index].isHidden = false;
    }
  };

  const handleAdditionalChange = (index, e) => {

    const { name, value } = e.target;
    const newDropdowns = [...dropdowns];
    newDropdowns[index].additionalFields[name] = value;

    if (index === 0) {
      const width = parseFloat(newDropdowns[index].additionalFields.field1) || 0;
      const height = parseFloat(newDropdowns[index].additionalFields.field2) || 0;
      const sqrFt = (width * height) / 144;
      newDropdowns[index].additionalFields.field3 = sqrFt.toFixed(2);
      const unitCost = parseFloat(newDropdowns[index].additionalFields.field4) || 0;
      const totalCost = (sqrFt * unitCost * 0.2).toFixed(2); // Update based on new square footage
      setValePersent(totalCost); // This triggers the useEffect to update staticUnitCosts

      console.log(totalCost)

    }

    else if (index === 17) {
      const width = parseFloat(newDropdowns[index].additionalFields.field1) || 0;
      const height = parseFloat(newDropdowns[index].additionalFields.field2) || 0;

      // Calculate Sqr/ft
      const sqrFt = (width + height + height) / 12; // Convert to square feet
      newDropdowns[index].additionalFields.field3 = sqrFt.toFixed(2); // Update the Sqr/ft field
    }
    else if (index === 18) {
      const width = parseFloat(newDropdowns[index].additionalFields.field1) || 0;
      const height = parseFloat(newDropdowns[index].additionalFields.field2) || 0;

      // Calculate Sqr/ft
      const sqrFt = (width + height + height) / 12; // Convert to square feet
      newDropdowns[index].additionalFields.field3 = sqrFt.toFixed(2); // Update the Sqr/ft field
    }

    else if (index === 20) {
      const width = parseFloat(newDropdowns[index].additionalFields.field1) || 0;
      const height = parseFloat(newDropdowns[index].additionalFields.field2) || 0;

      // Calculate Sqr/ft
      const sqrFt = (width * height) / 144; // Convert to square feet
      newDropdowns[index].additionalFields.field3 = sqrFt.toFixed(2); // Update the Sqr/ft field
    }

    setDropdowns(newDropdowns);
    saveToSessionStorage(newDropdowns);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = dropdowns.map((dropdown, index) => ({
      selectedOption: dropdown.selectedOption,
      additionalFields: dropdown.additionalFields,
      label: dropdownLabels[index],
      isHidden: dropdown.isHidden,
    }));

    navigate('/next-page', { state: { data: dataToSend, formData,id } });
  };

  const Backpage = (e) => {
    e.preventDefault();
    navigate('/');
  };




  return (
    <div className="form-container">
      
      <form className='responsive-form form-expand-width' onSubmit={handleSubmit}>
      <h2 className="form-heading">Door Configuration</h2>
        {Array.isArray(dropdowns) && dropdowns.map((dropdown, index) => (
        <div className="form-row">

          <div key={index} className="form-group full-width-block" style={{ display: dropdown.isHidden ? 'none' : 'block' }}>
            <label className='LabelTop2'>{dropdownLabels[index] || 'Select an option'}</label>
            <div className="inline-group full-width-block">
              {index === 12 || index === 14 ? ( // Check if the index is for input field
                <input
                  type="number"
                  placeholder="Enter value"

                  
                  value={dropdown.selectedOption || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    const newDropdowns = [...dropdowns];
                    newDropdowns[index].selectedOption = value;
                    setDropdowns(newDropdowns);
                    saveToSessionStorage(newDropdowns);
                  }}
                  className="inputsize2"
                  min="0"
                />


              ) :
                index === 6 || index === 7 || index === 13 ? ( // Check if the index is 6 or 7
                  dropdown.selectedOption === 'CUSTOM' ? (
                    <div className="input-field-wrapper">
                      <input
                        name="field1"
                        placeholder={index === 6 ? "Enter custom Value" : "Enter custom value"}
                        value={dropdown.additionalFields.field1 || ''}
                        onChange={(e) => handleAdditionalChange(index, e)}
                        className="inputsize3"
                        min="0"
                      />
                      <FaTimes
                        className="icon-cross"
                        onClick={() => {
                          const newDropdowns = [...dropdowns];
                          newDropdowns[index].showInputField = false;
                          newDropdowns[index].selectedOption = '';
                          setDropdowns(newDropdowns);
                          saveToSessionStorage(newDropdowns);
                        }}
                      />
                    </div>
                  ) : (
                    <select
                      value={dropdown.selectedOption}
                      onChange={(e) => handleOptionChange(index, e)}
                      className="dropdown"
                    >
                      <option value="">Select an option</option>
                      {dropdownOptions[index]?.map((option, idx) => (
                        <option key={idx} value={option}>{option}</option>
                      ))}
                    </select>
                  )
                ) : (
                  <select
                    value={dropdown.selectedOption}
                    onChange={(e) => handleOptionChange(index, e)}
                    className="dropdown"
                  >
                    <option value="">Select an option</option>
                    {dropdownOptions[index]?.map((option, idx) => (
                      <option key={idx} value={option}>{option}</option>
                    ))}
                  </select>
                )}
              {dropdown.selectedOption && dropdown.selectedOption !== 'No' && (
                <div className="input-fields">
                  {fieldLabels[index]?.map((label, idx) => {
                    const isHidden =
                      // (index === 1 &&(idx === 0 || idx === 1 || idx === 2))||  
                      (index === 1 && (idx === 1 || idx === 2)) ||
                      (index === 2 && (idx === 0 || idx === 1 || idx === 2 || idx === 3)) ||
                      (index === 3 && (idx === 2)) ||
                      (index === 4 && (idx === 2)) ||
                      (index === 5 && (idx === 0 || idx === 1 || idx === 2)) ||
                      (index === 6 && (idx === 0 || idx === 1 || idx === 2)) ||
                      (index === 7 && (idx === 0 || idx === 1 || idx === 2)) ||
                      (index === 8 && (idx === 0 || idx === 1 || idx === 2)) ||
                      (index === 9 && (idx === 0 || idx === 1 || idx === 2)) ||

                      (index === 10 && (idx === 2)) ||
                      (index === 11 && (idx === 2)) ||
                      (index === 12 && (idx === 2 || idx === 1)) ||
                      (index === 13 && (idx === 0 || idx === 2 || idx === 1)) ||
                      (index === 14 && (idx === 2 || idx === 1)) ||
                      (index === 15 && (idx === 0 || idx === 2 || idx === 1)) ||
                      (index === 16 && (idx === 2 || idx === 1)) ||
                      (index === 19 && (idx === 0 || idx === 2 || idx === 1)) ||
                      (index === 21 && (idx === 0 || idx === 2 || idx === 1 || idx === 3)) ||
                      (index === 22 && (idx === 0 || idx === 2 || idx === 1)) ||
                      (index === 23 && (idx === 0 || idx === 2 || idx === 1)) ||
                      (index === 24 && (idx === 0 || idx === 2 || idx === 1))

                    const isDropdown = (index === 3 && idx === 0) || (index === 4 && idx === 0);

                    return (
                      <div key={idx} className="input-field-group">
                        <label className='LabelTop'>{label}</label>
                        {isDropdown ? (
                          <select
                            className="dropdownField"
                            name={`field${idx + 1}`}
                            value={dropdown.additionalFields[`field${idx + 1}`] || ''} // Keep this as is to ensure it reflects the state
                            onChange={(e) => handleAdditionalChange(index, e)}
                          >
                            {/* <option value="">Select an option</option> */}
                            <option value="French Arch">French Arch</option>
                            <option value="EYEBROW">EYEBROW</option>
                            <option value="FULL ARCH">FULL ARCH</option>
                            <option value="ELLIPTICAL">ELLIPTICAL</option>
                          </select>

                        ) : index === 1 && idx === 0 ? ( // Custom dropdown for Roller Latches Prep

                          <select
                            className="dropdownField"
                            name={`field${idx + 1}`}
                            value={dropdown.additionalFields[`field${idx + 1}`] || ''}
                            onChange={(e) => handleAdditionalChange(index, e)}
                          >
                            <option value=" ">Select Option</option>
                            {
                              doorOption == "SINGLE DOOR" ?
                                <>
                                  <option value="Open In">Open In</option>
                                  <option value="Open Out">Open Out</option>
                                </> :

                                doorOption == "DOUBLE DOOR" ?
                                  <>
                                    <option value="Left Active">Left Active</option>
                                    <option value="Right Active">Right Active</option>
                                  
                                  </>
                                  :

                                  doorOption == "FOLDING DOOR" ?
                                    <>
                                    

                                      <option value="Right To Left">Right To Left</option>
                                      <option value="Left TO Right">Left To Right</option>
                                    </>
                                    :
                                    <>
                                      <option value="Right To Left">Right To Left</option>
                                      <option value="Left TO Right">Left To Right</option>
                                    </>
                            }

                          </select>
                        )
                          : index === 10 && idx === 0 ? ( // Custom dropdown for Roller Latches Prep

                            <select
                              className="dropdownField"
                              name={`field${idx + 1}`}
                              value={dropdown.additionalFields[`field${idx + 1}`] || ''}
                              onChange={(e) => handleAdditionalChange(index, e)}
                            >
                              <option value="">Select an option</option>
                              <option value="DELRCA430">DELRCA430</option>
                              <option value="EMT8801">EMT8801</option>
                              <option value="TBD">TBD</option>
                            </select>
                          ) : index === 11 && idx === 0 ? ( // Custom dropdown for Roller Latches Prep
                            <select
                              className="dropdownField"
                              name={`field${idx + 1}`}
                              value={dropdown.additionalFields[`field${idx + 1}`] || ''}
                              onChange={(e) => handleAdditionalChange(index, e)}
                            >
                              <option value="">Select an option</option>
                              <option value="DEL 18EFB">DEL 18EFB</option>
                              <option value="DEL 12EFB">DEL 12EFB</option>
                              <option value="DEL 18EFBZ">DEL 18EFBZ</option>
                              <option value="TBD">TBD  </option>
                            </select>
                          ) : index === 12 && idx === 0 ? ( // Custom dropdown for Roller Latches Prep
                            <select
                              className="dropdownField2"
                              name={`field${idx + 1}`}
                              value={dropdown.additionalFields[`field${idx + 1}`] || ''}
                              onChange={(e) => handleAdditionalChange(index, e)}
                            >
                              <option value="">Select an option</option>

                              <option value="AW44">AW44</option>
                              <option value="AW45">AW45</option>
                              <option value="AW46">AW46</option>
                              <option value="TBD">TBD  </option>

                            </select>
                          ) :
                           index === 14 && idx === 0 ? ( // Custom dropdown for Roller Latches Prep
                            <select
                              className="dropdownField"
                              name={`field${idx + 1}`}
                              value={dropdown.additionalFields[`field${idx + 1}`] || ''}
                              onChange={(e) => handleAdditionalChange(index, e)}
                            >
                              <option value="">Select an option</option>

                              <option value="EMTEK 8455 OR EQUAL">EMTEK 8455 OR EQUAL</option>


                            </select>
                          ) : index === 1 && idx === 1 ? ( // Custom dropdown for Roller Latches Prep
                            <select
                              className="dropdownField"
                              name={`field${idx + 1}`}
                              value={dropdown.additionalFields[`field${idx + 1}`] || ''}
                              onChange={(e) => handleAdditionalChange(index, e)}
                            >
                              <option value="">Select an option</option>
                              <option value="Right">Right</option>
                              <option value="Left">Left</option>



                            </select>
                          ) : index === 16 && idx === 0 ? ( // Custom dropdown for Roller Latches Prep
                            <select
                              className="dropdownField"
                              name={`field${idx + 1}`}
                              value={dropdown.additionalFields[`field${idx + 1}`] || ''}
                              onChange={(e) => handleAdditionalChange(index, e)}
                            >
                              <option value="">Select an option</option>
                              <option value=" 4"> 4</option>
                              <option value="4 1/2  ">4 1/2 </option>
                              <option value="5  ">5 </option>
                              <option value=" 5 1/2 "> 5 1/2</option>
                              <option value="6 "> 6</option>
                              <option value="6 1/2 ">6 1/2 </option>
                              <option value=" TBD">TBD </option>


                            </select>
                          ) : (
                            <input
                              className={`inputsize ${isHidden ? 'hidden-input' : ''}`}
                              type="number"
                              min="0"
                              name={`field${idx + 1}`}
                              placeholder={isHidden ? '' : label}
                              value={dropdown.additionalFields[`field${idx + 1}`] || ''}
                              onChange={(e) => handleAdditionalChange(index, e)}
                            />
                          )}
                        
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
          </div>
        ))}
      {id == 'undefined' ?   <div className='divcenter'>
        <button type="button" className="Back btn-design" onClick={Backpage}>Back</button> &nbsp; &nbsp;
        <button type="submit" className="Next btn-design" onClick={handleSubmit}>Next</button>
      </div> : 
      
      
<div className='divcenter'>
<button type="submit" className="Next btn-design" onClick={handleSubmit}>Next</button>
      </div>       }
     
  </form>
      <br />
      <br />
      <br />
    </div>
  );
};
export default DoorConfig;

